// Tipos básicos para o sistema de permissões
export type TProgramaOptions =
  | "Estoque"
  | "Financeiro"
  | "Comercial"
  | "Fiscal"
  | "Produção"
  | "Café"
  | "Leite"
  | "Configurações"
  | "Cadastros"
  | "Receituário Agronômico"
  | "Fabrica";

export type TFuncionalidadeOptions = string;

export interface IPermissionContext {
  permissoes: Record<TProgramaOptions, string[]> | null;
  procurarPermissoes: () => Promise<void>;
  verificarPermissoes: (programa: TProgramaOptions, funcionalidade?: TFuncionalidadeOptions) => boolean;
  verificarPermissaoPorId: (permissionId: TPermissionId) => boolean;
  removerPermissoes: () => void;
  isLoading: boolean;
}

export interface IPermissionGuardProps {
  permissionId: TPermissionId;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const PERMISSION_MAP = {

  // Estoque
  'estoque': { programa: 'Estoque' },
  'estoque.dashboard': { programa: 'Estoque', funcionalidade: 'Visualizar dashboard' },
  'estoque.ressuprimento': { programa: 'Estoque', funcionalidade: 'Solicitar ressuprimento' },
  'estoque.recalcular-saldo': { programa: 'Estoque', funcionalidade: 'Recalcular saldo de produtos' },
  'estoque.expedicao-pedidos': { programa: 'Estoque', funcionalidade: 'Expedição de pedidos' },
  'estoque.listar-produtos': { programa: 'Estoque', funcionalidade: 'Listar produtos' },
  'estoque.incluir-produto': { programa: 'Estoque', funcionalidade: 'Produto » Incluir produto' },
  'estoque.produto-listar-todos': { programa: 'Estoque', funcionalidade: 'Produto » Listar todos' },
  'estoque.ressuprimento-listar-todos': { programa: 'Estoque', funcionalidade: 'Ressuprimento » Listar todos' },


  'estoque.configuracoes': { programa: 'Estoque', funcionalidade: 'Configurações' },
  'estoque.configuracoes-gerenciar-sazonalidades': { programa: 'Estoque', funcionalidade: 'Configurações » Gerenciar sazonalidade' },
  'estoque.configuracoes-gerenciar-compradores': { programa: 'Estoque', funcionalidade: 'Configurações » Gerenciar compradores' },

  'estoque.solicitar-compra-produto': { programa: 'Estoque', funcionalidade: 'Compra » Solicitar compra de produto' },
  'estoque.listar-ocs': { programa: 'Estoque', funcionalidade: 'Compra » Listar OCs' },
  'estoque.listar-solicitacoes': { programa: 'Estoque', funcionalidade: 'Compra » Listar solicitações' },
  'estoque.listar-ordens-compra': { programa: 'Estoque', funcionalidade: 'Compra » Listar ordens de compra' },

  'estoque.entrada-produtos.registrar-recebimento': { programa: 'Estoque', funcionalidade: 'Entrada de produtos » Registrar recebimento' },
  'estoque.entrada-produtos.historico-entradas': { programa: 'Estoque', funcionalidade: 'Entrada de produtos » Histórico de entradas' },

  'estoque.listar-categorias': { programa: 'Estoque', funcionalidade: 'Categorias » Visualizar Listagem de Categorias' },
  'estoque.detalhar-produto.ultimas-compras': { programa: 'Estoque', funcionalidade: 'Detalhar produto » Ver últimas compras' },
  'estoque.detalhar-produto.ultimas-vendas': { programa: 'Estoque', funcionalidade: 'Detalhar produto » Ver últimas vendas' },
  'estoque.detalhar-produto.informacoes-produto': { programa: 'Estoque', funcionalidade: 'Detalhar produto » Ver informações do produto' },
  'estoque.detalhar-produto.vendas-mensais': { programa: 'Estoque', funcionalidade: 'Detalhar produto » Ver vendas mensais' },
  'estoque.ressuprimento.reverter-expedicao': { programa: 'Estoque', funcionalidade: 'Ressuprimento » Reverter expedição' },

  // Financeiro
  'financeiro': { programa: 'Financeiro' },
  'financeiro.dashboard': { programa: 'Financeiro', funcionalidade: 'Visualizar dashboard' },

  'financeiro.configuracoes': { programa: 'Financeiro', funcionalidade: 'Configurações' },
  'financeiro.configuracoes.bancos': { programa: 'Financeiro', funcionalidade: 'Configurações » Gerenciar bancos' },
  'financeiro.configuracoes.categorias': { programa: 'Financeiro', funcionalidade: 'Configurações » Categorias' },
  'financeiro.configuracoes.contas-bancarias': { programa: 'Financeiro', funcionalidade: 'Configurações » Gerenciar contas bancárias' },
  'financeiro.configuracoes.conta-corrente': { programa: 'Financeiro', funcionalidade: 'Conta corrente consumo » Configurações' },
  'financeiro.configuracoes.departamentos': { programa: 'Financeiro', funcionalidade: 'Configurações » Departamentos' },
  'financeiro.configuracoes.funcoes': { programa: 'Financeiro', funcionalidade: 'Configurações » Funções' },
  'financeiro.configuracoes.locais-cobranca': { programa: 'Financeiro', funcionalidade: 'Configurações » Locais de cobrança' },
  'financeiro.configuracoes.operadoras-cartao': { programa: 'Financeiro', funcionalidade: 'Configurações » Operadoras de cartão' },
  'financeiro.configuracoes.rateios': { programa: 'Financeiro', funcionalidade: 'Configurações » Rateios' },
  'financeiro.configuracoes.situacoes': { programa: 'Financeiro', funcionalidade: 'Configurações » Situações' },
  'financeiro.configuracoes.tipos-documento': { programa: 'Financeiro', funcionalidade: 'Configurações » Tipos de documento' },
  'financeiro.configuracoes.tef': { programa: 'Financeiro', funcionalidade: 'Configurações » TEF' },

  'financeiro.integracoes-bancarias': { programa: 'Financeiro', funcionalidade: 'Integração bancária' },

  'financeiro.limite-credito': { programa: 'Financeiro', funcionalidade: 'Limite de crédito » Abrir solicitação' },
  'financeiro.limite-credito-listar': { programa: 'Financeiro', funcionalidade: 'Limite de crédito » Listar todas' },
  'financeiro.limite-credito-atualizar-limites': { programa: 'Financeiro', funcionalidade: 'Limite de crédito » Atualização de limites' },

  'financeiro.contas-receber-editar-cartao': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Editar dados cartão título a receber' },
  'financeiro.contas-receber-data-retroativa': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Permitir data retroativa' },
  'financeiro.contas-receber-data-futura': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Permitir data futura' },
  'financeiro.incluir-titulo-receber': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Incluir título a receber' },
  'financeiro.listar-titulo-receber': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Listar todas' },
  'financeiro.registrar-recebimento': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Registrar recebimento' },
  'financeiro.listar-recibos': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Listar recibos' },
  'financeiro.contas-receber-permitir-desconto': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Registrar recebimento » Permitir desconto' },
  'financeiro.contas-receber-permitir-desconto-cupom': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Registrar recebimento » Permitir desconto com cupom' },
  'financeiro.contas-receber-editar': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Editar título a receber' },
  'financeiro.contas-receber-detalhar-calculo': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Registrar recebimento » Detalhar cálculo' },
  'financeiro.contas-receber-ignorar-gravacao-caixa-bancos': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Ignorar gravação caixa bancos' },
  'financeiro.contas-receber-solicitar-cancelamento-recibo': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Solicitar cancelamento de recibo' },
  'financeiro.contas-receber-cancelar-recibo': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Cancelar recibo' },
  'financeiro.contas-receber-listar-recebimentos-baixas': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Listar recebimentos e baixas' },
  'financeiro.contas-receber-imprimir-recebimentos-baixas': { programa: 'Financeiro', funcionalidade: 'Contas a receber » Imprimir recebimentos e baixas' },

  'financeiro.incluir-titulo-pagar': { programa: 'Financeiro', funcionalidade: 'Contas a pagar » Incluir título a pagar' },
  'financeiro.listar-titulo-pagar': { programa: 'Financeiro', funcionalidade: 'Contas a pagar » Listar todas' },
  'financeiro.registrar-pagamento': { programa: 'Financeiro', funcionalidade: 'Contas a pagar » Registrar pagamento' },
  'financeiro.contas-pagar-criacao-direta': { programa: 'Financeiro', funcionalidade: 'Contas a pagar » Criação direta de título a pagar' },
  'financeiro.contas-pagar-permitir-desconto': { programa: 'Financeiro', funcionalidade: 'Contas a pagar » Registrar pagamento » Permitir desconto' },

  'financeiro.ap-global': { programa: 'Financeiro', funcionalidade: 'Contas a pagar » Ap global' },

  'financeiro.cco-visualizar': { programa: 'Financeiro', funcionalidade: 'Conta corrente consumo » Visão geral' },
  'financeiro.cco-incluir-lancamento': { programa: 'Financeiro', funcionalidade: 'Conta corrente consumo » Incluir lançamento' },
  'financeiro.cco-realizar-fechamento': { programa: 'Financeiro', funcionalidade: 'Conta corrente consumo » Realizar fechamento' },
  'financeiro.cco-cancelar-fechamento': { programa: 'Financeiro', funcionalidade: 'Conta corrente consumo » Cancelar fechamento' },
  'financeiro.cco-excluir-fechamento': { programa: 'Financeiro', funcionalidade: 'Conta corrente consumo » Excluir fechamento' },

  'financeiro.caixa-bancos-incluir-lancamento': { programa: 'Financeiro', funcionalidade: 'Caixa e bancos » Incluir lançamento' },
  'financeiro.caixa-bancos-extrato-contas': { programa: 'Financeiro', funcionalidade: 'Caixa e bancos » Extrato de contas' },
  'financeiro.caixa-bancos-listar-lancamentos': { programa: 'Financeiro', funcionalidade: 'Caixa e bancos » Listar lançamentos' },

  'financeiro.cupons-adicionar-cupom': { programa: 'Financeiro', funcionalidade: 'Cupons » Adicionar cupom' },
  'financeiro.cupons-editar-cupom': { programa: 'Financeiro', funcionalidade: 'Cupons » Editar cupom' },
  'financeiro.cupons-excluir-cupom': { programa: 'Financeiro', funcionalidade: 'Cupons » Excluir cupom' },
  'financeiro.cupons-listar': { programa: 'Financeiro', funcionalidade: 'Cupons » Listar cupons' },

  'financeiro.cheques-incluir-cheque': { programa: 'Financeiro', funcionalidade: 'Cheques » Incluir cheque' },
  'financeiro.cheques-listar-cheques': { programa: 'Financeiro', funcionalidade: 'Cheques » Listar cheques' },
  'financeiro.cheques-listar-cheques-devolvidos': { programa: 'Financeiro', funcionalidade: 'Cheques » Listar cheques devolvidos' },

  'financeiro.fluxo-caixa-listar-simulacoes': { programa: 'Financeiro', funcionalidade: 'Fluxo de caixa » Listar simulações' },
  'financeiro.fluxo-caixa-gerar-simulacao': { programa: 'Financeiro', funcionalidade: 'Fluxo de caixa » Gerar simulação' },

  'comercial': { programa: 'Comercial' },
  'comercial.dashboard': { programa: 'Comercial', funcionalidade: 'Visualizar dashboard' },

  'comercial.criar-pedido': { programa: 'Comercial', funcionalidade: 'Pedidos » Criar pedido' },
  'comercial.aprovar-pedidos': { programa: 'Comercial', funcionalidade: 'Pedidos » Aprovar pedidos' },
  'comercial.cancelar-pedido': { programa: 'Comercial', funcionalidade: 'Pedidos » Cancelar pedido' },
  'comercial.realizar-pagamento': { programa: 'Comercial', funcionalidade: 'Pedidos » Realizar pagamento' },
  'comercial.realizar-expedicao': { programa: 'Comercial', funcionalidade: 'Pedidos » Realizar expedição' },
  'comercial.listar-pedidos': { programa: 'Comercial', funcionalidade: 'Pedidos » Listar todos' },
  'comercial.resumo-operacoes': { programa: 'Comercial', funcionalidade: 'Pedidos » Resumo operações' },
  'comercial.cancelar-expedicao-pedido': { programa: 'Comercial', funcionalidade: 'Pedidos » Cancelar expedição' },

  'comercial.devolucoes': { programa: 'Comercial', funcionalidade: 'Devoluções » Listar solicitações' },
  'comercial.produtos': { programa: 'Comercial', funcionalidade: 'Produto » Listar todos' },
  'comercial.incluir-produtos': { programa: 'Comercial', funcionalidade: 'Produto » Incluir produtos' },
  'comercial.notas-fiscais': { programa: 'Comercial', funcionalidade: 'Notas fiscais » Listar todas' },
  'comercial.configuracoes': { programa: 'Comercial', funcionalidade: 'Configurações' },
  'comercial.categorias': { programa: 'Comercial', funcionalidade: 'Configurações » Categorias' },
  'comercial.formas-pagamento': { programa: 'Comercial', funcionalidade: 'Configurações » Formas de pagamento' },
  'comercial.consultores': { programa: 'Comercial', funcionalidade: 'Configurações » Consultores' },
  'comercial.promocoes': { programa: 'Comercial', funcionalidade: 'Configurações » Promoções' },

  // Configurações
  'configuracoes.dashboard': { programa: 'Configurações', funcionalidade: 'Visualizar dashboard' },
  'configuracoes.usuarios': { programa: 'Configurações', funcionalidade: 'Gerenciar usuários' },
  'configuracoes.perfis': { programa: 'Configurações', funcionalidade: 'Gerenciar perfis' },
  'configuracoes.fluxos': { programa: 'Configurações', funcionalidade: 'Gerenciar fluxos' },
  'configuracoes.formularios': { programa: 'Configurações', funcionalidade: 'Gerenciar formulários' },
  'configuracoes.whatsapp': { programa: 'Configurações', funcionalidade: 'Whatsapp' },
  'configuracoes.mensagens': { programa: 'Configurações', funcionalidade: 'Gerenciar mensagens' },
  'configuracoes.copynorte': { programa: 'Configurações', funcionalidade: 'Gerenciar CopyNorte' },
  'configuracoes.cadastrar-certificado': { programa: 'Configurações', funcionalidade: 'Cadastrar certificado digital' },
  //Receituário Agronômico
  'receituario': { programa: 'Receituário Agronômico' },
  'receituario.dashboard': { programa: 'Receituário Agronômico', funcionalidade: 'Visualizar dashboard' },
  'receituario.incluir-agronomo': { programa: 'Receituário Agronômico', funcionalidade: 'Agrônomos » Incluir agronômo' },
  'receituario.listar-agronomos': { programa: 'Receituário Agronômico', funcionalidade: 'Agrônomos » Listar todos' },
  'receituario.incluir-cultura': { programa: 'Receituário Agronômico', funcionalidade: 'Culturas » Incluir cultura' },
  'receituario.listar-culturas': { programa: 'Receituário Agronômico', funcionalidade: 'Culturas » Listar todos' },
  'receituario.incluir-praga': { programa: 'Receituário Agronômico', funcionalidade: 'Pragas » Incluir praga' },
  'receituario.listar-pragas': { programa: 'Receituário Agronômico', funcionalidade: 'Pragas » Listar todos' },
  'receituario.incluir-ingrediente-ativo': { programa: 'Receituário Agronômico', funcionalidade: 'Ingredientes ativos » Incluir ingrediente ativo' },
  'receituario.listar-ingredientes-ativos': { programa: 'Receituário Agronômico', funcionalidade: 'Ingredientes ativos » Listar todos' },
  'receituario.incluir-prescricao': { programa: 'Receituário Agronômico', funcionalidade: 'Prescrições » Incluir prescrição' },
  'receituario.listar-prescricoes': { programa: 'Receituário Agronômico', funcionalidade: 'Prescrições » Listar todas' },
  'receituario.editar-prescricao': { programa: 'Receituário Agronômico', funcionalidade: 'Prescrições » Editar prescrição' },
  'receituario.incluir-agrotoxico': { programa: 'Receituário Agronômico', funcionalidade: 'Agrotóxicos » Incluir agrotóxico' },
  'receituario.listar-agrotoxicos': { programa: 'Receituário Agronômico', funcionalidade: 'Agrotóxicos » Listar todos' },
  'receituario.editar-agrotoxicos': { programa: 'Receituário Agronômico', funcionalidade: 'Agrotóxicos » Editar agrotóxico' },

  // Café
  'cafe': { programa: 'Café' },
  'cafe.dashboard': { programa: 'Café', funcionalidade: 'Visualizar dashboard' },
  'cafe.listar-lotes': { programa: 'Café', funcionalidade: 'Lista lotes de café' },

  // Cadastros
  'cadastros': { programa: 'Cadastros' },
  'cadastros.dashboard': { programa: 'Cadastros', funcionalidade: 'Visualizar dashboard' },
  'cadastros.cooperado.incluir': { programa: 'Cadastros', funcionalidade: 'Cooperado » Incluir cooperado' },
  'cadastros.cooperado.listar-todos': { programa: 'Cadastros', funcionalidade: 'Cooperado » Listar todos' },
  'cadastros.cliente.listar-todos': { programa: 'Cadastros', funcionalidade: 'Cliente » Listar todos' },
  'cadastros.fornecedor.listar-todos': { programa: 'Cadastros', funcionalidade: 'Fornecedor » Listar todos' },
  'cadastros.empregado.listar-todos': { programa: 'Cadastros', funcionalidade: 'Empregado » Listar todos' },
  'cadastros.loja.listar-todas': { programa: 'Cadastros', funcionalidade: 'Loja » Listar todas' },
  'cadastros.loja.incluir': { programa: 'Cadastros', funcionalidade: 'Loja » Incluir loja' },
  'cadastros.editar-situacao-financeira': { programa: 'Cadastros', funcionalidade: 'Cooperado » Editar situação financeira' },
  'cadastros.dados-financeiro-do-publico': { programa: 'Cadastros', funcionalidade: 'Cooperado » Dados financeiros do público' },

  // Fabrica
  'fabrica': { programa: 'Fabrica' },
  'fabrica.dashboard': { programa: 'Fabrica', funcionalidade: 'Visualizar dashboard' },
  'fabrica.configuracoes': { programa: 'Fabrica', funcionalidade: 'Configurações' },
  'fabrica.solicitar-insumos': { programa: 'Fabrica', funcionalidade: 'Fabrica » Solicitar insumos' },
  'fabrica.listar-todos': { programa: 'Fabrica', funcionalidade: 'Fabrica » Listar todos' },


  // Outras permissões
  'producao': { programa: 'Produção' }, //NÃO CRIADA
  'producao.dashboard': { programa: 'Produção', funcionalidade: 'Visualizar dashboard' }, //NÃO CRIADA

  'fiscal': { programa: 'Fiscal' },
  'fiscal.dashboard': { programa: 'Fiscal', funcionalidade: 'Visualizar dashboard' }, 
  'fiscal.notas-fiscais.listar-todas': { programa: 'Fiscal', funcionalidade: 'Notas Fiscais » Listar todas' }, 

  'leite': { programa: 'Leite' }, //NÃO CRIADA
  'leite.dashboard': { programa: 'Leite', funcionalidade: 'Visualizar dashboard' }, //NÃO CRIADA
} satisfies Record<string, { programa: TProgramaOptions; funcionalidade?: TFuncionalidadeOptions }>;

export type TPermissionId = keyof typeof PERMISSION_MAP;